import { adminReducer } from ".."

export const setInvestorsOnPage = (investorsOnPage) => (dispatch) => {
  dispatch(adminReducer.setInvestorsOnPage(investorsOnPage))
}